import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import { useTranslation } from "../i18n/LanguageContext";

const copy = {
    it: {
        title: "Seguici sui social",
        subtitle: "Foto, eventi e novità della stagione.",
        links: [
            { label: "Instagram", href: "https://www.instagram.com/" },
            { label: "Facebook", href: "https://www.facebook.com/" },
            { label: "TikTok", href: "https://www.tiktok.com/" }
        ]
    },
    en: {
        title: "Follow us on social",
        subtitle: "Photos, events and seasonal updates.",
        links: [
            { label: "Instagram", href: "https://www.instagram.com/" },
            { label: "Facebook", href: "https://www.facebook.com/" },
            { label: "TikTok", href: "https://www.tiktok.com/" }
        ]
    },
    de: {
        title: "Folgen Sie uns",
        subtitle: "Fotos, Events und Saison‑Updates.",
        links: [
            { label: "Instagram", href: "https://www.instagram.com/" },
            { label: "Facebook", href: "https://www.facebook.com/" },
            { label: "TikTok", href: "https://www.tiktok.com/" }
        ]
    }
};

const SocialLinksSection = ({ className = "" }) => {
    const { language } = useTranslation();
    const t = copy[language] || copy.it;

    return (
        <section className={`rounded-3xl bg-white p-6 text-slate-900 shadow-lg md:p-10 ${className}`}>
            <div className="flex flex-col gap-4 text-center md:flex-row md:items-center md:justify-between md:text-left">
                <div>
                    <h2 className="text-2xl font-semibold text-slate-900">{t.title}</h2>
                    <p className="mt-2 text-sm text-slate-600">{t.subtitle}</p>
                </div>
                <div className="flex flex-wrap justify-center gap-3 md:justify-start">
                    {t.links.map((link) => {
                        const Icon =
                            link.label === "Instagram"
                                ? FaInstagram
                                : link.label === "Facebook"
                                  ? FaFacebookF
                                  : FaTiktok;
                        return (
                            <a
                                key={link.label}
                                href={link.href}
                                target="_blank"
                                rel="noreferrer"
                                aria-label={link.label}
                                title={link.label}
                                className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-800 shadow-sm transition hover:border-slate-300 hover:text-slate-900"
                            >
                                <Icon size={18} />
                            </a>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SocialLinksSection;
